var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.80981H12.5",
    stroke: "#714FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.8098H14",
    stroke: "#714FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 5.80981V11.8098L16.6747 18.1792C17.2057 18.8327 16.7407 19.8098 15.8986 19.8098H2.10053C1.25849 19.8098 0.793425 18.8327 1.32442 18.1792L6.49964 11.8098V5.80981",
    stroke: "#714FFF",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 3.30981,
    rx: 0.499999,
    ry: 0.5,
    fill: "#714FFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 1.30981,
    rx: 0.500002,
    ry: 0.5,
    fill: "#714FFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 3.80981,
    rx: 1,
    ry: 1,
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabs);
export default __webpack_public_path__ + "static/media/Labs.e90330235761154bb6bae38bd5a1cd60.svg";
export { ForwardRef as ReactComponent };